import React from 'react'
import { type IntegrationServiceId } from '../../../../common/integrations'
import { CrossClientIntegrationIcon } from '../../CrossClientIntegrationIcon'
import { type CrossClientQueryDataSource } from '../../../../models/CrossClient'
import { ReactComponent as ZocksIcon } from '../../../../assets/images/ZocksIcon-primary.svg'
import { isZocksSource } from '../../utils'

type IconSize = 'sm' | 'md'

const sizeMap: Record<IconSize, string> = {
  sm: '0.75rem',
  md: '1rem',
}

interface CrossClientResultSourceIconProps {
  source: CrossClientQueryDataSource
  size?: IconSize
  dimension?: string
}

export const CrossClientResultDetailSourceIcon: React.FC<CrossClientResultSourceIconProps> = ({ source, size = 'sm', dimension: dimensionOverride }) => {
  const dimension = dimensionOverride ?? sizeMap[size]

  if (isZocksSource(source)) {
    return <ZocksIcon width={dimension} height={dimension} aria-hidden='true' focusable='false' />
  }

  return <CrossClientResultSourceIcon source={source} size={size} dimension={dimensionOverride} />
}

export const CrossClientResultSourceIcon: React.FC<CrossClientResultSourceIconProps> = ({ source, size = 'sm', dimension: dimensionOverride }) => {
  const dimension = dimensionOverride ?? sizeMap[size]

  if (source.type === 'integration') {
    return <CrossClientIntegrationIcon serviceId={source.integrationType as IntegrationServiceId} width={dimension} height={dimension} />
  }

  return null
}
